"use client";

import { Instagram, Linkedin, Music, Podcast, Video } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
const shopLinks = [{
  label: "Todos los Planes",
  to: "/PlansPage"
}, {
  label: "Resorts",
  to: "/PlansPage"
}, {
  label: "Hoteles",
  to: "/PlansPage"
}, {
  label: "Campos de Golf",
  to: "/PlansPage"
}, {
  label: "Complejos",
  to: "/PlansPage"
}];
const learnLinks = [{
  label: "Blog",
  to: "/HomePage"
}, {
  label: "Casos de Éxito",
  to: "/HomePage"
}, {
  label: "Tutoriales",
  to: "/HomePage"
}, {
  label: "Talleres",
  to: "/HomePage"
}, {
  label: "FAQ",
  to: "/HomePage"
}, {
  label: "Ayuda",
  to: "/ContactPage"
}];
const socials = [{
  label: "LinkedIn",
  icon: Linkedin,
  to: "#"
}, {
  label: "Spotify",
  icon: Music,
  to: "#"
}, {
  label: "Apple Podcasts",
  icon: Podcast,
  to: "#"
}, {
  label: "Vimeo",
  icon: Video,
  to: "#"
}, {
  label: "Instagram",
  icon: Instagram,
  to: "#"
}];
const legalLinks = [{
  label: "PRIVACIDAD",
  to: "/PrivacyPage"
}, {
  label: "TÉRMINOS",
  to: "/TermsPage"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[...Array(5)].map((_, i) => <div data-index={i} key={i} className="h-4 w-32 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="group relative inline-block text-sm text-foreground/70 hover:text-foreground transition-colors duration-300">
            <span className="relative">
              {item.label}
              <span className="absolute -bottom-0.5 left-0 h-px w-0 bg-primary transition-all duration-500 group-hover:w-full" />
            </span>
          </Link>
        </li>)}
    </ul>;
}
export default function PieDePGinaInformativo() {
  return <MenuProvider menu_id="16">
      <section data-section-id="3976" id="pie-de-página-informativo" className="relative bg-background text-foreground overflow-hidden border-t border-border">
        <div className="relative max-w-7xl mx-auto px-6 md:px-10 pt-20 pb-12">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
            <div className="md:col-span-5 lg:col-span-4 flex flex-col gap-8">
              <Link to="/" className="inline-block">
                <WvcLogo className="h-20 w-auto" />
              </Link>

              <p className="text-xl md:text-2xl italic leading-snug max-w-[320px] text-foreground/85" style={{
              fontFamily: "var(--font-serif)"
            }}>Every Arrival Matters</p>

              <div className="flex flex-col gap-2 text-xs tracking-wider text-muted-foreground" style={{
              fontFamily: "var(--font-mono)"
            }}>
                <p className="uppercase">8th The Green - Suite A</p>
                <p className="uppercase">DOVER — 19901 - DELAWARE - USA</p>
                
                <Link to="mailto:contacto@timearrival.com" className="uppercase hover:text-primary transition-colors duration-300 w-fit">CONTACTO@TIMEARRIVAL.COM</Link>
              </div>
            </div>

            <div className="md:col-span-3 lg:col-span-3">
              <h3 className="text-xs tracking-[0.2em] text-primary mb-6 uppercase font-default font-medium" style={{
              fontFamily: "var(--font-mono)"
            }}>SECCIONES</h3>
              <FooterMenuConsumer />
            </div>
          </div>
        </div>

        <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-8">
          <div className="border-t border-b border-border py-8 flex items-center justify-center">
            <div className="w-full h-px bg-linear-to-r from-transparent via-primary/20 to-transparent" />
          </div>
        </div>

        <div className="relative max-w-7xl mx-auto px-6 md:px-10 pb-12">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
            <p className="text-[10px] tracking-[0.2em] text-muted-foreground uppercase order-1" style={{
            fontFamily: "var(--font-mono)"
          }}>
              &copy; 2025 TIMEARRIVAL TECHNOLOGIES
            </p>

            <div className="flex items-center gap-4 order-2 md:order-3 text-[10px] tracking-[0.2em] uppercase" style={{
            fontFamily: "var(--font-mono)"
          }}>
              {legalLinks.map((link, i) => <span data-index={i} key={link.label} className="flex items-center gap-4">
                  <Link to={link.to} className="text-muted-foreground hover:text-foreground transition-colors duration-300">
                    {link.label}
                  </Link>
                  {i < legalLinks.length - 1 && <span className="text-muted-foreground/40">/</span>}
                </span>)}
            </div>
          </div>
        </div>

        <div className="relative w-full overflow-hidden pointer-events-none select-none" aria-hidden="true">
          <div className="text-center leading-none whitespace-nowrap" style={{
          fontFamily: "var(--font-serif)",
          fontSize: "clamp(120px, 28vw, 280px)",
          fontWeight: 500,
          color: "hsl(222 47% 11% / 0.05)",
          transform: "translateY(40%)",
          letterSpacing: "-0.04em"
        }}>
            ARRIVAL
          </div>
        </div>
      </section>
    </MenuProvider>;
}